import { useNavigate } from 'react-router-dom';
import CloudOffIcon from '@mui/icons-material/CloudOff';
import { Box, Typography } from '@mui/material';
import { t } from 'i18next';

import { PATH } from '~/constants/route-path';
import { COLORS } from '~/styles/colors';

export function PQrCodeDeactivated() {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        height: '100vh',
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        position: 'relative',
      }}
    >
      <CloudOffIcon style={{ color: COLORS.purple, width: 80, height: 80 }} />

      <Box textAlign="center">
        <Typography mt={3} fontSize={30} maxWidth={400}>
          {t('errorPages:qrDeactivated')}
        </Typography>
      </Box>

      <Typography sx={{ color: COLORS.gray06, mt: 1, fontSize: 14 }}>
        {t('errorPages:qrDeactivatedSubTitle1')}
        <span onClick={() => navigate(PATH.LOGIN)} style={{ color: COLORS.blue, cursor: 'pointer' }}>
          {t('errorPages:qrDeactivatedSubTitle2')}
        </span>
        {t('errorPages:qrDeactivatedSubTitle3')}
      </Typography>
    </Box>
  );
}
